// extracted by mini-css-extract-plugin
module.exports = {"searchMatchResultsContainer":"SearchMatchResults_searchMatchResultsContainer__2Pvvk","searchMatchResult":"SearchMatchResults_searchMatchResult__1MaFk"};